import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Remove static shell after React hydrates for better FCP
const root = document.getElementById("root")!;
const staticShell = document.getElementById("static-shell");

createRoot(root).render(<App />);

// Clean up static shell after React renders
if (staticShell) {
  requestAnimationFrame(() => {
    staticShell.remove();
  });
}

// Register service worker for caching and offline support (production only)
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('[SW] Service worker registered:', registration.scope);
        
        // Check for updates periodically
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000); // Check every hour
        
        // Handle updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                console.log('[SW] New version available, will activate on next visit');
              }
            });
          }
        });
      })
      .catch((error) => {
        console.error('[SW] Service worker registration failed:', error);
      });
  });
}
